export const getMinutesRemaining = (time: number) =>
  Math.ceil(time / (1000 * 60));
